// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d0495472","455":"d3990a70","977":"c7e89ef0"}[chunkId] + ".chunk.js";
};